module.exports = __webpack_public_path__ + "static/img/grid4.5342ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/grid4.png
// module id = vOmP
// module chunks = 0